import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useGetApp from "src/hooks/useGetApp";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import { useUpdateConfigApp } from "src/services/organizations/commands/configuration";
import { AppConfigType } from "src/types/apps";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../context";
import DialogContext from "../PolicyConfigCard/EntitiesListDialog/context";

const useSaveAppConfig = () => {
	const { state, actions } = useContext(Context);
	const dialogContext = useContext(DialogContext);

	const org = useGetOrg();
	const app = useGetApp();
	const { mutate, isPending } = useUpdateConfigApp();

	const queryClient = useQueryClient();
	const { translate } = useLocales();

	const isCustom = state.selectedConfig === "CUSTOM";

	const onSuccess = () => {
		SnackbarUtils.success(translate("app_config.saved_success"));
		actions.hideSelectEntitiesDialog();
		const newValue: AppConfigType = {
			selectionMode: isCustom ? "CUSTOM" : "BY_STATUS",
			entityStatus: isCustom ? "CUSTOM" : state.selectedConfig
		};
		queryClient.setQueryData([app?.id ?? "", "config"], newValue);
		if (dialogContext.entitiesSelected.length > 0)
			actions.onSetEntities(dialogContext.entitiesSelected);
	};

	const onError = () => {
		actions.hideSelectEntitiesDialog();
		SnackbarUtils.error(translate("app_config.saved_error"));
	};

	const onChangeAppConfig = () => {
		mutate(
			{
				orgId: org.id,
				appId: app?.id ?? "",
				entityStatus: isCustom ? null : state.selectedConfig,
				selectionMode: isCustom ? "CUSTOM" : "BY_STATUS",
				entities: dialogContext.entitiesSelected
			},
			{ onSuccess, onError }
		);
	};

	return { onChangeAppConfig, isLoading: isPending };
};

export default useSaveAppConfig;
